import { AppRouteNames } from "@/shared/@types/AppRouteNames";
import type { RouteLocationNormalizedLoaded } from "vue-router";

const PageNotFoundView = () =>
  import("@/shared/views/PageNotFoundView/PageNotFoundView.vue");
const CardsOverviewView = () =>
  import("@/app/wsc-management-app/cards-overview/CardsOverviewView/CardsOverviewView.vue");
const TransactionsView = () =>
  import("@/app/wsc-management-app/transactions/TransactionsView/TransactionsView.vue");
const InvoicesView = () =>
  import("@/app/wsc-management-app/invoices/InvoicesView/InvoicesView.vue");
const SettingsView = () =>
  import("@/app/wsc-management-app/settings/SettingsView/SettingsView.vue");

export const routes = [
  {
    path: "",
    name: AppRouteNames.WscCardsOverview,
    meta: {
      titleKey: "wscManagement.menu.cardsOverview",
    },
    props: (route: RouteLocationNormalizedLoaded) => ({
      cardQueryNr: route.query.cardNr,
      individualPermissionIdsQueryParam: Array.isArray(
        route.query.individualPermissionIds,
      )
        ? route.query.individualPermissionIds.filter(
            (permissionId): permissionId is string =>
              typeof permissionId === "string",
          )
        : typeof route.query.individualPermissionIds === "string"
          ? [route.query.individualPermissionIds]
          : [],
    }),
    component: CardsOverviewView,
  },
  {
    path: "invoices",
    name: AppRouteNames.WscInvoices,
    meta: {
      titleKey: "wscManagement.menu.invoices",
    },
    component: InvoicesView,
  },
  {
    path: "transactions",
    name: AppRouteNames.WscTransactions,
    meta: {
      titleKey: "wscManagement.menu.transactions",
    },
    props: (route: RouteLocationNormalizedLoaded) => ({
      transactionQueryNr: route.query.transactionNr,
      searchQueryParam: route.query.search,
    }),
    component: TransactionsView,
  },
  {
    path: "settings",
    name: AppRouteNames.WscSettings,
    meta: {
      titleKey: "wscManagement.menu.settings",
    },
    component: SettingsView,
  },
  {
    path: ":pathMatch(.*)*",
    name: AppRouteNames.WscNotFound,
    meta: {
      titleKey: "shared.error.page.notFoundError.title",
    },
    component: PageNotFoundView,
    props: {
      homeRouteName: AppRouteNames.WscCardsOverview,
    },
  },
];
